/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { Hidden } from '@material-ui/core';

import WidgetsCarouselContainer from 'components/widgets/WidgetsCarouselContainer';
import WidgetsDoubleContainer from 'components/pages/Content/WidgetsDoubleContainer';
import { ICustomTheme } from 'interfaces';
import { compareDateToNow } from '../../../core/utils/date.helpers';
import Widget from './Widget';
import { WidgetDoubleFree } from './WidgetDoubleFree';
import { WIDGETS_TYPE } from './constants';
import { ContentBlocWidgetType } from './types';

const StyledContainer = styled.div<{ theme: ICustomTheme }>(({ theme }) => ({
  padding: theme.spacing(7, 1.5, 2),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(3),
  },
}));

const ContentBlocWidget = ({
  widget,
}: ContentBlocWidgetType): JSX.Element | null => {
  const { diffusionStartAt, diffusionEndAt } = widget;
  const isActive =
    compareDateToNow(diffusionStartAt) + compareDateToNow(diffusionEndAt) === 0;

  if (isActive || diffusionEndAt === null) {
    switch (widget['@type']) {
      case WIDGETS_TYPE.DOUBLE:
        return (
          <Hidden smDown={!widget.isMobile}>
            <Hidden smDown>
              <StyledContainer>
                <WidgetsDoubleContainer
                  left={widget.widgets[0]}
                  right={widget.widgets[1]}
                />
              </StyledContainer>
            </Hidden>
            {/* display widget double like 2 simple widgets when breakpoint sm & under */}
            <Hidden mdUp>
              <StyledContainer>
                <Widget widget={widget.widgets[0]} />
              </StyledContainer>
              <StyledContainer>
                <Widget widget={widget.widgets[1]} />
              </StyledContainer>
            </Hidden>
          </Hidden>
        );
      case WIDGETS_TYPE.DOUBLE_FREE:
        return <WidgetDoubleFree widget={widget} />;
      case WIDGETS_TYPE.CAROUSEL:
        return (
          <Hidden smDown={!widget.isMobile}>
            <StyledContainer>
              <WidgetsCarouselContainer widgets={widget.widgets} />
            </StyledContainer>
          </Hidden>
        );
      default:
        return (
          <Hidden smDown={!widget.isMobile}>
            <StyledContainer>
              <Widget widget={widget} />
            </StyledContainer>
          </Hidden>
        );
    }
  }

  return null;
};

export default ContentBlocWidget;
